import React, { useMemo } from 'react';
import { getPolyglot } from '../../../../i18n';
import { TextValue } from '../../../../theme/components/Forms';
import { PolicyAPIResponse } from '../../../../redux/incident/api/Policy.model';
import eventCategories from '../../../../redux/incident/EventCategory/eventCategories.json';

interface AlarmsStringProps {
  policy?: PolicyAPIResponse;
}

function getSelectedCategoryNames(
  filters: PolicyAPIResponse['filters'],
  polyglot: ReturnType<typeof getPolyglot>
): string {
  const selectedIds = new Set<string>();
  for (const filter of filters) {
    switch (filter.type) {
      case 'EVENT_GROUP_FILTER':
        return polyglot.t('incident.policy.policy_alarms_all');
      case 'EVENT_ID_FILTER':
        filter.spec.ids.forEach((id) => selectedIds.add(id));
        break;
    }
  }

  const matchedCategories = eventCategories
    .filter((cat) => cat.eventIds.some((id) => selectedIds.has(id)))
    .map(
      (cat) =>
        polyglot.t(`incident.policy.edit.categories.${cat.id}`) ?? cat.name_en
    );

  return matchedCategories.join(', ');
}

function AlarmsString(props: AlarmsStringProps) {
  const polyglot = getPolyglot();
  const { policy } = props;

  const categoryNames = useMemo(() => {
    if (!policy?.filters) return '';
    return getSelectedCategoryNames(policy.filters, polyglot);
  }, [policy?.filters, polyglot]);

  return (
    <TextValue label={polyglot.t('incident.policy.policy_alarms')}>
      {categoryNames}
    </TextValue>
  );
}

export default AlarmsString;
